<template>
    <b-container>
        <h2>Εφεδρικό δυναμικό</h2>
        <br>
        <Message v-if="msgVisible" v-bind:msgClass="msgClass" v-bind:message="message"></Message>
        <div>
            <b-tabs content-class="mt-4" value="activeTab" justified>
                <b-tab lazy title="Αναζήτηση εφέδρου βάσει ΑΣΜ" active>
                    <br/>
                    <SearchUsersComponent></SearchUsersComponent>
                </b-tab>
                <b-tab lazy title="Χρήστες με ΕΦΠ" @click="fetchEfpUsers">
                    <EfpUsers ref="efpUsers"></EfpUsers>
                </b-tab>
                <b-tab lazy title="Μη επιβεβαιωμένοι χρήστες" @click="fetchUnverifiedUsers"
                       v-if="this.$store.getters.userRole === 'ROLE_ADMIN' ||
                            this.$store.getters.userRole === 'ROLE_SUPERADMIN'">
                    <UnverifiedUsers ref="unverifiedUsers"></UnverifiedUsers>
                </b-tab>
                <b-tab lazy title="Επιβεβαιωμένοι χρήστες" @click="fetchVerifiedUsers"
                       v-if="this.$store.getters.userRole === 'ROLE_ADMIN' ||
                        this.$store.getters.userRole === 'ROLE_SUPERADMIN' ||
                        this.$store.getters.userRole === 'ROLE_MANAGER'||
                        this.$store.getters.userRole === 'ROLE_SXHMATISMOS'">
                    <VerifiedUsers ref="verifiedUsers"></VerifiedUsers>
                </b-tab>
            </b-tabs>
        </div>
    </b-container>
</template>

<script>

import Message from '@/components/Message.vue';
import EfpUsers from "@/views/EfpUsers.vue";
import UnverifiedUsers from '@/views/UnverifiedUsers.vue';
import VerifiedUsers from '@/views/VerifiedUsers.vue';
import SearchUsersComponent from '@/components/SearchUsersComponent'

export default {
    name: "UserDetailsAdmin",
    components: {
        Message,
        EfpUsers,
        UnverifiedUsers,
        VerifiedUsers,
        SearchUsersComponent
    },

    data() {
        return {
            activeTab: "",
            message: "",
            msgVisible: false,
            msgClass: "",
        }
    },

    created() {
        //TODO check
        if (this.$store.getters.userRole === "ROLE_USER") {
            this.$router.push("/");
        }
    },
    computed: {
        isDisabled() {
            return this.$store.getters.userRole === "ROLE_MANAGER"
        },
    },
    methods: {
        fetchEfpUsers() {
            this.$refs.efpUsers.pageChange(1);
        },
        fetchUnverifiedUsers() {
            this.$refs.unverifiedUsers.pageChange(1);
        },
        fetchVerifiedUsers() {
            this.$refs.verifiedUsers.pageChange(1);
        }
    }
}
</script>

<style scoped>

</style>
